export type CharacterStatus = 'available' | 'development';
export type CharacterVisual = 'knight' | 'sorceress' | 'skeleton';

export type CharacterDefinition = {
  id: string;
  name: string;
  role: string;
  status: CharacterStatus;
  visual: CharacterVisual;
};

export const PLAYABLE_CHARACTER_ID = 'exiled-knight';

export const CHARACTER_CHOICES: readonly CharacterDefinition[] = [
  {
    id: PLAYABLE_CHARACTER_ID,
    name: 'ИЗГНАННЫЙ РЫЦАРЬ',
    role: 'ЖИВУЧИЙ БЛИЖНИЙ БОЙ',
    status: 'available',
    visual: 'knight',
  },
  {
    id: 'sorceress',
    name: 'ВОЛШЕБНИЦА',
    role: 'В РАЗРАБОТКЕ',
    status: 'development',
    visual: 'sorceress',
  },
  {
    id: 'skeleton',
    name: 'СКЕЛЕТ',
    role: 'В РАЗРАБОТКЕ',
    status: 'development',
    visual: 'skeleton',
  },
] as const;
